import { render, staticRenderFns } from "./StaffPerformance.vue?vue&type=template&id=78b66887&"
import script from "./StaffPerformance.vue?vue&type=script&lang=js&"
export * from "./StaffPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports